export default function Configure($stateProvider) {
    $stateProvider.state('mesctrl', {
        parent: 'common',
        url: '/mesctrl',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.SECURITE_MATERIEL" | translate }}'
        }
    });

    $stateProvider.state('mesctrl.list', {
        url: '/list',
        template: '<mesures></mesures>',
        rights: { domain: 'controles', right: 'read' },
        ncyBreadcrumb: {
            parent: 'mesctrl',
            label: '{{ "MESURES.BREADCRUMBS.CONTROLES_LIST" | translate}}'
        },
        navigation: {
            menu: 'securite_materiel_donnees',
            translate: 'MESURES.BREADCRUMBS.CONTROLES_LIST',
            order: 5
        },
        search: 'MESURES.BREADCRUMBS.CONTROLES_LIST'
    });

    $stateProvider.state('mesctrl.list.detail', {
        url: '/{id}',
        template: '<mesure-detail></mesure-detail>',
        rights: { domain: 'controles', right: 'read' },
        ncyBreadcrumb: {
            parent: 'controles.list',
            label: '{{ "MESURES.BREADCRUMBS.CONTROLE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('mesctrl.new', {
        url: '/new',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'controles', right: 'create' },
        ncyBreadcrumb: {
            parent: 'mesctrl.list',
            label: '{{ "MESURES.BREADCRUMBS.CONTROLE_NEW" | translate}}'
        },
        search: 'MESURES.BREADCRUMBS.CONTROLE_NEW'
    });

    $stateProvider.state('mesctrl.edit', {
        url: '/{id}/edit',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'controles', right: 'update' },
        ncyBreadcrumb: {
            parent: 'mesctrl.list',
            label: '{{ "MESURES.BREADCRUMBS.CONTROLE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('mesctrl.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'mesctrl.new' },
        ncyBreadcrumb: {
            parent: 'mesctrl.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('mesctrl.duplicate', {
        url: '/{id}/duplicate',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'mesctrl', right: 'create' },
        ncyBreadcrumb: {
            parent: 'mesctrl.list',
            label: '{{ "MESURES.BREADCRUMBS.CONTROLE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
